import React from 'react';
import { useForm } from '../../context/FormContext';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Label } from '../ui/label';

const NATIONALITIES = [
  'British', 'Irish', 'Welsh', 'Scottish', 'Romanian', 'Polish', 'Afghan', 'Albanian', 
  'Algerian', 'American', 'Andorran', 'Angolan', 'Argentinean', 'Armenian', 'Australian', 
  'Austrian', 'Azerbaijani', 'Bahamian', 'Bahraini', 'Bangladeshi', 'Barbadian', 'Belarusian', 
  'Belgian', 'Belizean', 'Beninese', 'Bhutanese', 'Bolivian', 'Bosnian', 'Brazilian', 
  'Bruneian', 'Bulgarian', 'Burkinabe', 'Burmese', 'Burundian', 'Cambodian', 'Cameroonian', 
  'Canadian', 'Cape Verdean', 'Central African', 'Chadian', 'Chilean', 'Chinese', 'Colombian', 
  'Comoran', 'Congolese', 'Costa Rican', 'Croatian', 'Cuban', 'Cypriot', 'Czech', 'Danish', 
  'Djiboutian', 'Dominican', 'Dutch', 'East Timorese', 'Ecuadorean', 'Egyptian', 'Emirian', 
  'Equatorial Guinean', 'Eritrean', 'Estonian', 'Ethiopian', 'Fijian', 'Filipino', 'Finnish', 
  'French', 'Gabonese', 'Gambian', 'Georgian', 'German', 'Ghanaian', 'Greek', 'Grenadian', 
  'Guatemalan', 'Guinean', 'Guyanese', 'Haitian', 'Honduran', 'Hungarian', 'Icelandic', 
  'Indian', 'Indonesian', 'Iranian', 'Iraqi', 'Israeli', 'Italian', 'Ivorian', 'Jamaican', 
  'Japanese', 'Jordanian', 'Kazakhstani', 'Kenyan', 'Kuwaiti', 'Kyrgyz', 'Laotian', 'Latvian', 
  'Lebanese', 'Liberian', 'Libyan', 'Lithuanian', 'Luxembourger', 'Macedonian', 'Malagasy', 
  'Malawian', 'Malaysian', 'Maldivian', 'Malian', 'Maltese', 'Mauritanian', 'Mauritian', 
  'Mexican', 'Moldovan', 'Monacan', 'Mongolian', 'Moroccan', 'Mozambican', 'Namibian', 
  'Nepalese', 'New Zealander', 'Nicaraguan', 'Nigerian', 'North Korean', 'Norwegian', 'Omani', 
  'Pakistani', 'Panamanian', 'Paraguayan', 'Peruvian', 'Portuguese', 'Qatari', 'Russian', 
  'Rwandan', 'Saudi', 'Senegalese', 'Serbian', 'Singaporean', 'Slovakian', 'Slovenian', 
  'Somali', 'South African', 'South Korean', 'Spanish', 'Sri Lankan', 'Sudanese', 'Surinamer', 
  'Swedish', 'Swiss', 'Syrian', 'Taiwanese', 'Tajik', 'Tanzanian', 'Thai', 'Togolese', 'Tongan', 
  'Trinidadian', 'Tunisian', 'Turkish', 'Ugandan', 'Ukrainian', 'Uruguayan', 'Uzbekistani', 
  'Venezuelan', 'Vietnamese', 'Yemeni', 'Zambian', 'Zimbabwean'
];

export const NationalityStep = () => {
  const { formData, updateFormData } = useForm();

  return (
    <div className="space-y-6" data-testid="nationality-step">
      <div className="text-center">
        <h2 className="text-xl md:text-2xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
          About You
        </h2>
        <p className="text-slate-600 hidden md:block">Let us know your nationality</p>
      </div>

      <div className="max-w-md mx-auto">
        <Label className="text-sm font-medium text-slate-700 mb-2 block">
          Nationality
        </Label>
        <Select 
          value={formData.nationality} 
          onValueChange={(value) => updateFormData({ nationality: value })}
        >
          <SelectTrigger className="h-12" data-testid="nationality-select">
            <SelectValue placeholder="Select your nationality" />
          </SelectTrigger>
          <SelectContent className="max-h-60">
            {NATIONALITIES.map(nationality => (
              <SelectItem 
                key={nationality} 
                value={nationality}
                data-testid={`nationality-${nationality.toLowerCase().replace(/\s/g, '-')}`}
              >
                {nationality}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default NationalityStep;
